import React from 'react'


import TopLevelScreen from 'components/TopLevelScreen'
import ModalScreen from 'components/ModalScreen'
import ChromelessScreen from 'components/ChromelessScreen'
import Page from 'components/Page'

import createLogger from 'debug'

import { useIsModal, usePage } from 'navigation'

import { ReactFC } from 'types'
import { AppTransitions } from 'navigation/StackTransitions'
import { MainPageContainer } from './navigation/MainPageContainer'
import { ScreenContextProvider } from 'navigation/screen-context'
import { useUnmount } from 'ahooks'


// to enable localStorage.debug = 'info:*'
const info = createLogger('info:ui')


export const Screen: ReactFC = ({ children }) => {
  const modal = useIsModal()
  if (modal) {
    return <ModalScreen>{children}</ModalScreen>
  }
  return <>{children}</>
  // return <TopLevelScreen>{children}</TopLevelScreen>
}

const Stack = () => {
  const { page, place } = usePage()
  const component = page.getPageComponent(place)
  useUnmount(()=> {
    console.log("app lifecylcle: stack unmount")
  })

  if (page.isChromeless) {
    return (
        <ChromelessScreen key={place.type}>{component}</ChromelessScreen>
    )
  }

  info('App place: %o, page: %o', place, page)
  return (
    <ScreenContextProvider>
      <AppTransitions>
        <Screen>
          <Page>
            <MainPageContainer>
              {component}
            </MainPageContainer>
          </Page>
        </Screen>
      </AppTransitions>
    </ScreenContextProvider>
  )
}

export default Stack